import { Tooltip, withStyles } from '@material-ui/core';

const CustomMaterialTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#383847',
    color: '#FFFFFF',
    fontSize: 13,
    padding:'8px'
  },
}))(Tooltip);

export default CustomMaterialTooltip;
